import { Basics, isTouch } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { CSS } from '../_app/cuchillo/utils/CSS';
import WebGLSketch from '../_app/cuchillo/3D/WebGLSketch';
import Line from './Line';
import GridCanvas from './GridCanvas';

export default class Drag {
    _container;
    isDragging = false;
    drag = {
        initial: { x: 0, y: 0 },
        current: { x: 0, y: 0 }
    };
    velocity = { x: 0, y: 0 };

    opts = {
        dragStart: () => { },
        dragMove: () => { },
        dragEnd: () => { }
    }

    _calls = {
        onDragStart: () => {
            window.clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(() => {
                this.isDragging = true;
                this._container.classList.add('__dragging');
                this.opts.dragStart();
            }, 150);
        },
        onDragEnd: () => {
            window.clearTimeout(this.timeoutId);

            this.isDragging = false;
            this._container.classList.remove('__dragging');
            this.opts.dragEnd();
        },
        mouseDown: (e) => {
            this.isDragging = true;
            this.velocity = {
                x: 0,
                y: 0
            }

            this.drag.old =
                this.drag.current =
                this.drag.click = {
                    x: Math.floor(isTouch ? e.touches[0].screenX : e.clientX),
                    y: Math.floor(isTouch ? e.touches[0].screenY : e.clientY),
                };

            this._calls.onDragStart();
        },
        mouseMove: (e) => {
            e.preventDefault();
            if (!this.isDragging) return;

            this.drag.current = {
                x: Math.floor(isTouch ? e.touches[0].screenX : e.clientX),
                y: Math.floor(isTouch ? e.touches[0].screenY : e.clientY),
            };

            this.velocity = {
                x: this.drag.current.x - this.drag.old.x,
                y: this.drag.current.y - this.drag.old.y,
            }

            this.drag.old = this.drag.current;

            this.opts.dragMove(this.velocity);
        },
        mouseUp: () => {
            if (!this.isDragging) return;
            this.isDragging = false;
            const inertiaX = 50 * this.velocity.x;
            const inertiaY = 50 * this.velocity.y;

            this._calls.onDragEnd();
            this.opts.dragMove({ x: inertiaX, y: inertiaY });
        },
        // Windows/Chrome dispara el drag natiu d'HTML5 sobre <a> i <img>
        // (cursor "forbidden" + el punter es queda segrestat i mai arriba el mouseup,
        // deixant isDragging=true). El prevenim a la superfície de drag.
        preventNativeDrag: (e) => {
            e.preventDefault();
        }
    }

    constructor(__container, opts = {}) {
        this.opts = {
            ...this.opts,
            ...opts
        };

        this._container = __container;
    }

    mount() {
        this._container.addEventListener(Basics.downEvent, this._calls.mouseDown);
        this._container.addEventListener(Basics.moveEvent, this._calls.mouseMove);
        this._container.addEventListener(Basics.upEvent, this._calls.mouseUp);
        this._container.addEventListener('dragstart', this._calls.preventNativeDrag);
        window.addEventListener(Basics.upEvent, this._calls.mouseUp);
    }

    unmount() {
        this._container.removeEventListener(Basics.downEvent, this._calls.mouseDown);
        this._container.removeEventListener(Basics.moveEvent, this._calls.mouseMove);
        this._container.removeEventListener(Basics.upEvent, this._calls.mouseUp);
        this._container.removeEventListener('dragstart', this._calls.preventNativeDrag);
        window.removeEventListener(Basics.upEvent, this._calls.mouseUp);
    }

    dispose() {
        window.removeEventListener(Basics.upEvent, this._calls.mouseUp);
        if (this._container) this._container.removeEventListener('dragstart', this._calls.preventNativeDrag);
        this._container = null;
    }
}

export class Drag__Item {
    dom;
    index;
    _x = 0;
    _y = 0;
    _z = 0;

    width = 0;
    height = 0;
    top = 0;
    left = 0;

    get x() { return this._x; }
    set x(__n) { this._x = __n; }

    get y() { return this._y; }
    set y(__n) { this._y = __n; }

    get z() { return this._z; }
    set z(__n) { this._z = __n; }

    get realX() { return this.left + this._x; }
    get realY() { return this.top + this._y; }

    constructor(__dom, __index) {
        this.dom = __dom;
        this.index = __index;
        this.resize();
    }

    update() { }

    loop(__force = false) {
        this.dom.style[CSS.transform] = CSS.matrix3D(this._x, this._y, this._z);
    }

    resize() {
        const rect = this.dom.getBoundingClientRect();
        this.width = rect.width;
        this.height = rect.height;
        this.top = rect.top;
        this.left = rect.left;
    }

    dispose() { }
}